





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { HttpEndpoint } from '@/types/core-push';

@Component
export default class HttpEndpointView extends Vue {
  
  @Prop({ default: {},  type: Object}) httpEndpoint!: HttpEndpoint;

  getHeaderName(header:string):string {
    return header.split(':')[0].trim();
  }
  
  formatHeader(header:string):string {

    const headerList = header.split(':');
    const headerName = headerList[0].trim();
    let headerValue = headerList[1].trim();

    headerValue = headerValue.replace(/./g, '#');
    headerValue = headerValue.substring(0, 15);

    return `${headerName} : ${headerValue}`;

  }

  formatUrl(url:string):string {
    return url.length > 35 ? `${url.substring(0,32)}...` : url;
  }
}
